// removed by extract-text-webpack-plugin
module.exports = {"bg":"_1CKYQ","base":"_3M_hv","sectionHeader":"_3N_nI","title":"_3lsxZ","content":"_233rz","spinner":"lRDbp","list":"_2Brq0","form":"_3LgUW","group":"_34J1Y","footer":"yNg9U"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PersonalInfo/EditPersonalInfoView.scss
// module id = 1935
// module chunks = 0